export const SITE = {
  // Temporary contact email — replace with the official address when confirmed
  email: "contact@payungoren.com",
  whatsappCorporate: "6285959300020",
  whatsappCorporateDisplay: "+62 859 5930 0020",
  whatsappActivation: "628112333580",
  whatsappActivationDisplay: "+62 811 2333 580",
  instagram: "@PAYUNG.OC",
  instagramUrl: "https://instagram.com/payung.oc",
  location: "North Bekasi, Indonesia",
};
